/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let memberFiltersMainCatApiURL = root.memberFiltersMainCatApiUrl.link;
let memberFiltersProCatApiURL = root.memberFiltersProCatApiUrl.link;
let memberFiltersProSubCatApiURL = root.memberFiltersProSubCatApiUrl.link;
let memberFiltersIndexApiURL = root.memberFiltersIndexApiUrl.link;
import Vue from 'vue'
export default {
  state: {
    getMemberMainFiltersState:{},
    getMemberMainFiltersByIdState:{},
    getMemberProfessionalFiltersState:{},
    getMemberProfessionalSubFiltersState:{}
  },
  mutations: {
    getMemberMainFiltersMutation(state, value) {
      Vue.set(state, 'getMemberMainFiltersState', value);
    },
    getMemberMainFiltersByIdMutation(state, value) {
      Vue.set(state, 'getMemberMainFiltersByIdState', value);
    },
    getMemberProfessionalFiltersMutation(state, value) {
      Vue.set(state, 'getMemberProfessionalFiltersState', value);
    },
    getMemberProfessionalSubFiltersMutation(state, value) {
      Vue.set(state, 'getMemberProfessionalSubFiltersState', value);
    }
  },
  actions: {
    // Get Member Main Filters
    getMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberFiltersMainCatApiURL, payload).then(res => {
              context.commit('getMemberMainFiltersMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Member Main Filters
    createMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(memberFiltersMainCatApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Main Filter Details By Id
    getMemberMainFilterDetailsByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberFiltersMainCatApiURL + payload.id + '/').then(res => {
              context.commit('getMemberMainFiltersByIdMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Member Main Filters
    updateMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(memberFiltersMainCatApiURL + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Member Main Filters
    updateINdexOfMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(memberFiltersIndexApiURL + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Delete Member Main Filters
    deleteMemberMainFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(memberFiltersMainCatApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Professional Filters
    getMemberProfessionalFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberFiltersProCatApiURL + payload.id + '/', payload).then(res => {
              context.commit('getMemberProfessionalFiltersMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Member Professional Filters
    createMemberProfessionalFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(memberFiltersProCatApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Professional Filter Details By Id
    getMemberProfessionalFilterDetailsByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberFiltersProCatApiURL + payload.id).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Member Professional Filters
    updateMemberProfessionalFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(memberFiltersProCatApiURL + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Delete Member Professional Filters
    deleteMemberProfessionalFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(memberFiltersProCatApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Professional Sub Filters
    getMemberProfessionalSubFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberFiltersProSubCatApiURL, payload).then(res => {
              context.commit('getMemberProfessionalSubFiltersMutation', res.data);
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Create Member Professional Sub Filters
    createMemberProfessionalSubFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(memberFiltersProSubCatApiURL, payload).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Get Member Professional Sub Filter Details By Id
    getMemberProfessionalSubFilterDetailsByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(memberFiltersProSubCatApiURL + payload.id).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Update Member Professional SUb Filters
    updateMemberProfessionalSubFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.patch(memberFiltersProSubCatApiURL + payload.data.id + '/', payload.data.data).then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
    // Delete Member Professional Sub Filters
    deleteMemberProfessionalSubFilterAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(memberFiltersProSubCatApiURL + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
    getMemberMainFiltersGetters: state => state.getMemberMainFiltersState,
    getMemberMainFiltersByIdGetters: state => state.getMemberMainFiltersByIdState,
    getMemberProfessionalFiltersGetters: state => state.getMemberProfessionalFiltersState,
    getMemberProfessionalSubFiltersGetters: state => state.getMemberProfessionalSubFiltersState,
  }
}